export const SALESDASHBOARD = {
  DASHBOARDCURRENTLISTS: 'dashboard_current_lists',
  DASHBOARDSUMMARY: 'sales_dashboard_summary',
  DASHBOARDCHANGESTORE: 'dashboard_change_store',
  DASHBOARDLISTWITHMASTER: 'dashboard_list_master',
};
